/**
 * The help centre taxonomy, defined once.
 *
 * Deliberately a closed set. Free-text categories drift — the same way the
 * work item tag vocabulary had to be pruned from 16 to 13 once `improvements`
 * had spread across half the backlog and stopped selecting anything.
 *
 * The rule for placing an article: categorise by the job the customer is
 * doing, not the system involved. "Your invite hasn't arrived" is Getting
 * started even though it is about TradingView, because getting started is
 * what the customer is trying to do.
 *
 * An article that genuinely fits two categories is usually two articles — or
 * the second meaning belongs in `keywords`, which is what search reads.
 */
export const HELP_CATEGORIES = [
  { id: "getting-started", label: "Getting started" },
  { id: "automation", label: "Automation" },
  { id: "strategies", label: "Strategies" },
  { id: "add-ons", label: "Add-ons" },
  { id: "billing", label: "Billing" },
] as const;

export type HelpCategoryId = (typeof HELP_CATEGORIES)[number]["id"];

const LABELS = new Map<string, string>(
  HELP_CATEGORIES.map((c) => [c.id, c.label])
);

export function isHelpCategory(value: string): value is HelpCategoryId {
  return LABELS.has(value);
}

export function categoryLabel(id: HelpCategoryId): string {
  return LABELS.get(id) ?? id;
}

/** Display order on the index, driven by the declaration order above. */
export function categoryRank(id: HelpCategoryId): number {
  return HELP_CATEGORIES.findIndex((c) => c.id === id);
}
